import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-question-inter",
  "use": "foquz-icon-question-inter-usage",
  "viewBox": "0 0 24 20",
  "content": "<symbol viewBox=\"0 0 24 20\" fill=\"none\" id=\"foquz-icon-question-inter\"><path d=\"M5 5.429V1h14v5M5 14.571V19h14v-5m0 0a4 4 0 000-8m0 8a4 4 0 010-8M9 10a4 4 0 11-8 0 4 4 0 018 0z\" stroke=\"currentColor\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol